<ion-content class="ion-align-items-center ion-justify-content-center content-class">
  <ion-grid class="bg-transparent">
    <ion-row>
      <ion-col></ion-col>
      <ion-col size="10" class="tarjet">
        <ion-row>
          <ion-col size="12" class="verticalRight">
            <fa-icon (click)="backToLogin()" class="font-big color-red" [icon]="faService.faX"></fa-icon>
          </ion-col>
        </ion-row>
        <ion-row class="vertical">
          <ion-col size="12" class="vertical">
            <ion-img class="headerImg" src="assets/logos/logo_1.png"></ion-img>
          </ion-col>
        </ion-row>
        <ion-row justify-content-center>
          <ion-col align-self-center size-md="12" size-lg="12" size-xl="12" size-xs="12" class="ion-text-left">
            <div text-center class="ion-text-center">&nbsp;
              <fa-icon class="fontVh25" [icon]="faService.faKey"></fa-icon>
              &nbsp;Recuperación de contraseña
            </div>
            <div padding>
              <ng-container *ngIf="estado==0">
                <ion-item>
                  <ion-label position="stacked" class="tituloLabel">Usuario</ion-label>
                  <ion-input label="" type="text" name="usuario" placeholder="Añada usuario..." [(ngModel)]="username">
                  </ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked" class="tituloLabel">Correo electrónico</ion-label>
                  <ion-input label="" type="text" name="usuario" [(ngModel)]="email"
                    placeholder="Añada correo electrónico.." (keyup.enter)="validar()"></ion-input>
                </ion-item>
                <ng-container *ngIf="isWeb==true">
                  <p>{{platform}}</p>
                  <!-- <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (reset)="handleReset()" (expire)="handleExpire()"
                    (load)="handleLoad()" (success)="handleSuccess($event)" [useGlobalDomain]="false" [size]="size"
                    [hl]="lang" [theme]="theme" [type]="type" formControlName="recaptcha">
                  </ngx-recaptcha2> -->
                  <!-- <div #recaptchaContainer></div> -->
                </ng-container>
              </ng-container>
              <div *ngIf="estado==1">
                <ion-item>
                  <ion-label position="stacked" class="tituloLabel">Código</ion-label>
                  <ion-input label="" type="text" name="codigo" placeholder="Inserte el codigo..." [(ngModel)]="codigo"
                    (keyup.enter)="validar()">
                  </ion-input>
                </ion-item>
              </div>
              <div *ngIf="estado==2">
                <ion-item>
                  <ion-label position="stacked" class="tituloLabel">Nueva contraseña</ion-label>
                  <ion-input label="" type="password" name="newpassword" placeholder="Añada contraseña..."
                    [(ngModel)]="newpassword">
                  </ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked" class="tituloLabel">Repita nueva contraseña</ion-label>
                  <ion-input label="" (keyup.enter)="validar()" type="password" name="newpassword2"
                    [(ngModel)]="newpassword2" placeholder="Añada la misma contraseña.."></ion-input>
                </ion-item>
              </div>
            </div>
            <ion-row>
              <ion-col size="12" class="ion-no-padding ion-text-center">
                <ion-label class="mensajeError">{{error}}</ion-label>
              </ion-col>
            </ion-row>
            <ion-row style="margin-top: 20px">
              <ion-col size="12" class="ion-no-padding ion-text-center">
                <ion-button [disabled]="loading == true" size="large" (click)="validar()" expand="block" fill="solid">
                  <span *ngIf="loading == false">Continuar</span>
                  <span *ngIf="loading == true"><mat-spinner [diameter]="15" mode="indeterminate"></mat-spinner></span>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="showExtraLogos">
          <ion-col class="vertical" size="6">
            <ion-img src="assets/logos/xunta-azul.png" (ionError)="logoLoadError($event)" class="img-logo"></ion-img>
          </ion-col>
          <ion-col class="vertical" size="6">
            <ion-img src="assets/logos/FEMP.png" (ionError)="logoLoadError($event)" class="img-logo"></ion-img>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-no-padding">
            <span class="text-version">{{version}}</span>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col></ion-col>
    </ion-row>
  </ion-grid>
</ion-content>